import React from "react";
import { createRoot } from 'react-dom/client'
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const container = document.getElementById("root");
const root = createRoot(container)

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "rgba(255,255,255,.8)",
    },
    success: {
      main: "#1EAA52",
    },
    warning: {
      main: "#FFD11B",
    },
  },
});

root.render(
  <BrowserRouter>
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </BrowserRouter>);
